var Pt = Object.defineProperty, Lt = Object.defineProperties;
var At = Object.getOwnPropertyDescriptors;
var Ue = Object.getOwnPropertySymbols;
var Ft = Object.prototype.hasOwnProperty, It = Object.prototype.propertyIsEnumerable;
var We = (a, t, r) => t in a ? Pt(a, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : a[t] = r, H = (a, t) => {
  for (var r in t || (t = {}))
    Ft.call(t, r) && We(a, r, t[r]);
  if (Ue)
    for (var r of Ue(t))
      It.call(t, r) && We(a, r, t[r]);
  return a;
}, K = (a, t) => Lt(a, At(t));
var de = (a, t, r) => new Promise((s, o) => {
  var l = (u) => {
    try {
      n(r.next(u));
    } catch (h) {
      o(h);
    }
  }, f = (u) => {
    try {
      n(r.throw(u));
    } catch (h) {
      o(h);
    }
  }, n = (u) => u.done ? s(u.value) : Promise.resolve(u.value).then(l, f);
  n((r = r.apply(a, t)).next());
});
import A from "react";
function nt(a, t) {
  if (t.length < a)
    throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ne(a) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ne = function(r) {
    return typeof r;
  } : ne = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ne(a);
}
function Ye(a) {
  nt(1, arguments);
  var t = Object.prototype.toString.call(a);
  return a instanceof Date || ne(a) === "object" && t === "[object Date]" ? new Date(a.getTime()) : typeof a == "number" || t === "[object Number]" ? new Date(a) : ((typeof a == "string" || t === "[object String]") && typeof console != "undefined" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function qt(a, t) {
  return nt(2, arguments), Ye(a).getTime() - Ye(t).getTime();
}
var L = {}, U = {}, Je;
function Bt() {
  if (Je) return U;
  Je = 1;
  var a = U && U.__assign || function() {
    return a = Object.assign || function(s) {
      for (var o, l = 1, f = arguments.length; l < f; l++) {
        o = arguments[l];
        for (var n in o) Object.prototype.hasOwnProperty.call(o, n) && (s[n] = o[n]);
      }
      return s;
    }, a.apply(this, arguments);
  };
  Object.defineProperty(U, "__esModule", { value: !0 });
  var t = {
    delayFirstAttempt: !1,
    jitter: "none",
    maxDelay: 1 / 0,
    numOfAttempts: 10,
    retry: function() {
      return !0;
    },
    startingDelay: 100,
    timeMultiple: 2
  };
  function r(s) {
    var o = a(a({}, t), s);
    return o.numOfAttempts < 1 && (o.numOfAttempts = 1), o;
  }
  return U.getSanitizedOptions = r, U;
}
var X = {}, x = {}, Z = {}, Q = {}, ee = {}, $e;
function Ut() {
  if ($e) return ee;
  $e = 1, Object.defineProperty(ee, "__esModule", { value: !0 });
  function a(t) {
    var r = Math.random() * t;
    return Math.round(r);
  }
  return ee.fullJitter = a, ee;
}
var te = {}, Ve;
function Wt() {
  if (Ve) return te;
  Ve = 1, Object.defineProperty(te, "__esModule", { value: !0 });
  function a(t) {
    return t;
  }
  return te.noJitter = a, te;
}
var Ge;
function Yt() {
  if (Ge) return Q;
  Ge = 1, Object.defineProperty(Q, "__esModule", { value: !0 });
  var a = Ut(), t = Wt();
  function r(s) {
    switch (s.jitter) {
      case "full":
        return a.fullJitter;
      case "none":
      default:
        return t.noJitter;
    }
  }
  return Q.JitterFactory = r, Q;
}
var ze;
function st() {
  if (ze) return Z;
  ze = 1, Object.defineProperty(Z, "__esModule", { value: !0 });
  var a = Yt(), t = (
    /** @class */
    (function() {
      function r(s) {
        this.options = s, this.attempt = 0;
      }
      return r.prototype.apply = function() {
        var s = this;
        return new Promise(function(o) {
          return setTimeout(o, s.jitteredDelay);
        });
      }, r.prototype.setAttemptNumber = function(s) {
        this.attempt = s;
      }, Object.defineProperty(r.prototype, "jitteredDelay", {
        get: function() {
          var s = a.JitterFactory(this.options);
          return s(this.delay);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(r.prototype, "delay", {
        get: function() {
          var s = this.options.startingDelay, o = this.options.timeMultiple, l = this.numOfDelayedAttempts, f = s * Math.pow(o, l);
          return Math.min(f, this.options.maxDelay);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(r.prototype, "numOfDelayedAttempts", {
        get: function() {
          return this.attempt;
        },
        enumerable: !0,
        configurable: !0
      }), r;
    })()
  );
  return Z.Delay = t, Z;
}
var He;
function Jt() {
  if (He) return x;
  He = 1;
  var a = x && x.__extends || /* @__PURE__ */ (function() {
    var l = function(f, n) {
      return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, h) {
        u.__proto__ = h;
      } || function(u, h) {
        for (var c in h) h.hasOwnProperty(c) && (u[c] = h[c]);
      }, l(f, n);
    };
    return function(f, n) {
      l(f, n);
      function u() {
        this.constructor = f;
      }
      f.prototype = n === null ? Object.create(n) : (u.prototype = n.prototype, new u());
    };
  })(), t = x && x.__awaiter || function(l, f, n, u) {
    function h(c) {
      return c instanceof n ? c : new n(function(p) {
        p(c);
      });
    }
    return new (n || (n = Promise))(function(c, p) {
      function k(m) {
        try {
          y(u.next(m));
        } catch (O) {
          p(O);
        }
      }
      function b(m) {
        try {
          y(u.throw(m));
        } catch (O) {
          p(O);
        }
      }
      function y(m) {
        m.done ? c(m.value) : h(m.value).then(k, b);
      }
      y((u = u.apply(l, f || [])).next());
    });
  }, r = x && x.__generator || function(l, f) {
    var n = { label: 0, sent: function() {
      if (c[0] & 1) throw c[1];
      return c[1];
    }, trys: [], ops: [] }, u, h, c, p;
    return p = { next: k(0), throw: k(1), return: k(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
      return this;
    }), p;
    function k(y) {
      return function(m) {
        return b([y, m]);
      };
    }
    function b(y) {
      if (u) throw new TypeError("Generator is already executing.");
      for (; n; ) try {
        if (u = 1, h && (c = y[0] & 2 ? h.return : y[0] ? h.throw || ((c = h.return) && c.call(h), 0) : h.next) && !(c = c.call(h, y[1])).done) return c;
        switch (h = 0, c && (y = [y[0] & 2, c.value]), y[0]) {
          case 0:
          case 1:
            c = y;
            break;
          case 4:
            return n.label++, { value: y[1], done: !1 };
          case 5:
            n.label++, h = y[1], y = [0];
            continue;
          case 7:
            y = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (c = n.trys, !(c = c.length > 0 && c[c.length - 1]) && (y[0] === 6 || y[0] === 2)) {
              n = 0;
              continue;
            }
            if (y[0] === 3 && (!c || y[1] > c[0] && y[1] < c[3])) {
              n.label = y[1];
              break;
            }
            if (y[0] === 6 && n.label < c[1]) {
              n.label = c[1], c = y;
              break;
            }
            if (c && n.label < c[2]) {
              n.label = c[2], n.ops.push(y);
              break;
            }
            c[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        y = f.call(l, n);
      } catch (m) {
        y = [6, m], h = 0;
      } finally {
        u = c = 0;
      }
      if (y[0] & 5) throw y[1];
      return { value: y[0] ? y[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(x, "__esModule", { value: !0 });
  var s = st(), o = (
    /** @class */
    (function(l) {
      a(f, l);
      function f() {
        return l !== null && l.apply(this, arguments) || this;
      }
      return f.prototype.apply = function() {
        return t(this, void 0, void 0, function() {
          return r(this, function(n) {
            return [2, this.isFirstAttempt ? !0 : l.prototype.apply.call(this)];
          });
        });
      }, Object.defineProperty(f.prototype, "isFirstAttempt", {
        get: function() {
          return this.attempt === 0;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(f.prototype, "numOfDelayedAttempts", {
        get: function() {
          return this.attempt - 1;
        },
        enumerable: !0,
        configurable: !0
      }), f;
    })(s.Delay)
  );
  return x.SkipFirstDelay = o, x;
}
var W = {}, Ke;
function $t() {
  if (Ke) return W;
  Ke = 1;
  var a = W && W.__extends || /* @__PURE__ */ (function() {
    var s = function(o, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, n) {
        f.__proto__ = n;
      } || function(f, n) {
        for (var u in n) n.hasOwnProperty(u) && (f[u] = n[u]);
      }, s(o, l);
    };
    return function(o, l) {
      s(o, l);
      function f() {
        this.constructor = o;
      }
      o.prototype = l === null ? Object.create(l) : (f.prototype = l.prototype, new f());
    };
  })();
  Object.defineProperty(W, "__esModule", { value: !0 });
  var t = st(), r = (
    /** @class */
    (function(s) {
      a(o, s);
      function o() {
        return s !== null && s.apply(this, arguments) || this;
      }
      return o;
    })(t.Delay)
  );
  return W.AlwaysDelay = r, W;
}
var Xe;
function Vt() {
  if (Xe) return X;
  Xe = 1, Object.defineProperty(X, "__esModule", { value: !0 });
  var a = Jt(), t = $t();
  function r(o, l) {
    var f = s(o);
    return f.setAttemptNumber(l), f;
  }
  X.DelayFactory = r;
  function s(o) {
    return o.delayFirstAttempt ? new t.AlwaysDelay(o) : new a.SkipFirstDelay(o);
  }
  return X;
}
var Ze;
function Gt() {
  if (Ze) return L;
  Ze = 1;
  var a = L && L.__awaiter || function(f, n, u, h) {
    function c(p) {
      return p instanceof u ? p : new u(function(k) {
        k(p);
      });
    }
    return new (u || (u = Promise))(function(p, k) {
      function b(O) {
        try {
          m(h.next(O));
        } catch (F) {
          k(F);
        }
      }
      function y(O) {
        try {
          m(h.throw(O));
        } catch (F) {
          k(F);
        }
      }
      function m(O) {
        O.done ? p(O.value) : c(O.value).then(b, y);
      }
      m((h = h.apply(f, n || [])).next());
    });
  }, t = L && L.__generator || function(f, n) {
    var u = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, h, c, p, k;
    return k = { next: b(0), throw: b(1), return: b(2) }, typeof Symbol == "function" && (k[Symbol.iterator] = function() {
      return this;
    }), k;
    function b(m) {
      return function(O) {
        return y([m, O]);
      };
    }
    function y(m) {
      if (h) throw new TypeError("Generator is already executing.");
      for (; u; ) try {
        if (h = 1, c && (p = m[0] & 2 ? c.return : m[0] ? c.throw || ((p = c.return) && p.call(c), 0) : c.next) && !(p = p.call(c, m[1])).done) return p;
        switch (c = 0, p && (m = [m[0] & 2, p.value]), m[0]) {
          case 0:
          case 1:
            p = m;
            break;
          case 4:
            return u.label++, { value: m[1], done: !1 };
          case 5:
            u.label++, c = m[1], m = [0];
            continue;
          case 7:
            m = u.ops.pop(), u.trys.pop();
            continue;
          default:
            if (p = u.trys, !(p = p.length > 0 && p[p.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              u = 0;
              continue;
            }
            if (m[0] === 3 && (!p || m[1] > p[0] && m[1] < p[3])) {
              u.label = m[1];
              break;
            }
            if (m[0] === 6 && u.label < p[1]) {
              u.label = p[1], p = m;
              break;
            }
            if (p && u.label < p[2]) {
              u.label = p[2], u.ops.push(m);
              break;
            }
            p[2] && u.ops.pop(), u.trys.pop();
            continue;
        }
        m = n.call(f, u);
      } catch (O) {
        m = [6, O], c = 0;
      } finally {
        h = p = 0;
      }
      if (m[0] & 5) throw m[1];
      return { value: m[0] ? m[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(L, "__esModule", { value: !0 });
  var r = Bt(), s = Vt();
  function o(f, n) {
    return n === void 0 && (n = {}), a(this, void 0, void 0, function() {
      var u, h;
      return t(this, function(c) {
        switch (c.label) {
          case 0:
            return u = r.getSanitizedOptions(n), h = new l(f, u), [4, h.execute()];
          case 1:
            return [2, c.sent()];
        }
      });
    });
  }
  L.backOff = o;
  var l = (
    /** @class */
    (function() {
      function f(n, u) {
        this.request = n, this.options = u, this.attemptNumber = 0;
      }
      return f.prototype.execute = function() {
        return a(this, void 0, void 0, function() {
          var n, u;
          return t(this, function(h) {
            switch (h.label) {
              case 0:
                if (this.attemptLimitReached) return [3, 7];
                h.label = 1;
              case 1:
                return h.trys.push([1, 4, , 6]), [4, this.applyDelay()];
              case 2:
                return h.sent(), [4, this.request()];
              case 3:
                return [2, h.sent()];
              case 4:
                return n = h.sent(), this.attemptNumber++, [4, this.options.retry(n, this.attemptNumber)];
              case 5:
                if (u = h.sent(), !u || this.attemptLimitReached)
                  throw n;
                return [3, 6];
              case 6:
                return [3, 0];
              case 7:
                throw new Error("Something went wrong.");
            }
          });
        });
      }, Object.defineProperty(f.prototype, "attemptLimitReached", {
        get: function() {
          return this.attemptNumber >= this.options.numOfAttempts;
        },
        enumerable: !0,
        configurable: !0
      }), f.prototype.applyDelay = function() {
        return a(this, void 0, void 0, function() {
          var n;
          return t(this, function(u) {
            switch (u.label) {
              case 0:
                return n = s.DelayFactory(this.options, this.attemptNumber), [4, n.apply()];
              case 1:
                return u.sent(), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, f;
    })()
  );
  return L;
}
var zt = Gt();
let re;
const Ht = new Uint8Array(16);
function Kt() {
  if (!re && (re = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !re))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return re(Ht);
}
const R = [];
for (let a = 0; a < 256; ++a)
  R.push((a + 256).toString(16).slice(1));
function Xt(a, t = 0) {
  return (R[a[t + 0]] + R[a[t + 1]] + R[a[t + 2]] + R[a[t + 3]] + "-" + R[a[t + 4]] + R[a[t + 5]] + "-" + R[a[t + 6]] + R[a[t + 7]] + "-" + R[a[t + 8]] + R[a[t + 9]] + "-" + R[a[t + 10]] + R[a[t + 11]] + R[a[t + 12]] + R[a[t + 13]] + R[a[t + 14]] + R[a[t + 15]]).toLowerCase();
}
const Zt = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Qe = {
  randomUUID: Zt
};
function Qt(a, t, r) {
  if (Qe.randomUUID && !a)
    return Qe.randomUUID();
  a = a || {};
  const s = a.random || (a.rng || Kt)();
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, Xt(s);
}
function er(a) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  for (let s = 0; s < a; s++) {
    const o = Math.floor(Math.random() * t.length);
    r += t[o];
  }
  return r;
}
function tr() {
  return (Math.floor(Math.random() * 999) + 1).toString().padStart(3, "0");
}
const rr = Qt();
class fr {
  constructor(t) {
    this.messageTimeoutThreshold = 3e4, this.messageTimeoutCheckFrequency = 15e3, this.fatalRecoveryCheckFrequency = 5e3, this.lastStreamSubscriptionHash = "", this.stopped = !0, this.timesConnected = 0, this.socketBaseUrl = t.socketBaseUrl, this.onWarning = t.onWarning, this.onFatal = t.onFatal, this.fetchSocketToken = t.fetchSocketToken, this.onMessage = t.onMessage, this.onSocketStatusChange = t.onSocketStatusChange, this.onOutOfOrderMessage = t.onOutOfOrderMessage, this.streamBroadcaster = t.streamBroadcaster, typeof t.fatalRecoveryCheckFrequency != "undefined" && (this.fatalRecoveryCheckFrequency = t.fatalRecoveryCheckFrequency), typeof t.messageTimeoutCheckFrequency != "undefined" && (this.messageTimeoutCheckFrequency = t.messageTimeoutCheckFrequency), typeof t.messageTimeoutThreshold != "undefined" && (this.messageTimeoutThreshold = t.messageTimeoutThreshold), this.streamBroadcaster.registerParentSocket(this);
  }
  getSocketStatus() {
    var t, r;
    return (r = (t = this.socket) == null ? void 0 : t.status) != null ? r : "CONNECTING";
  }
  getTimesConnected() {
    return this.timesConnected;
  }
  getPodName() {
    return this.podName;
  }
  setPodName(t) {
    this.podName = t;
  }
  getApplicationName() {
    return this.applicationName;
  }
  setApplicationName(t) {
    this.applicationName = t;
  }
  setOnMessage(t) {
    this.onMessage = t;
  }
  setOnSocketStatusChange(t) {
    this.onSocketStatusChange = t;
  }
  getStreamsLastMessageMapBeforeLastSocketClosure() {
    return this.streamsLastMessageMapBeforeLastSocketClosure;
  }
  start() {
    this.stopped = !1, this.initiateFatalRecoveryLoop(), this.connectToSocket();
  }
  stop() {
    this.stopped = !0, this.fatalRecoveryTimeoutId && clearTimeout(this.fatalRecoveryTimeoutId), this.messageMonitorTimeoutId && clearTimeout(this.messageMonitorTimeoutId), this.fetchSocketTokenTimeoutId && clearTimeout(this.fetchSocketTokenTimeoutId), this.setClosedSocket();
  }
  getSocketToken() {
    return de(this, null, function* () {
      let t;
      try {
        t = yield zt.backOff(() => this.fetchSocketToken(), {
          numOfAttempts: 5,
          // means our longest potential wait will be 32s (1s * 2^5)
          startingDelay: 1e3,
          // in ms
          jitter: "full"
        });
      } catch (r) {
        throw new Error("Could not retrieve socketToken");
      }
      return t;
    });
  }
  /**
   * A socket is considered CONNECTING until its `onopen` listener is called.
   *   A socket will subsequently shift to CONNECTED when its onopen listener is called.
   */
  connectToSocket() {
    return de(this, null, function* () {
      var s;
      if (((s = this.socket) == null ? void 0 : s.status) === "CONNECTING")
        return;
      this.socket = {
        status: "CONNECTING"
      };
      let t;
      try {
        t = yield this.getSocketToken();
      } catch (o) {
        return this.setFatalSocket("auth_failure");
      }
      this.fetchSocketTokenTimeoutId = setTimeout(() => {
        this.setFatalSocket("connect_timeout");
      }, 3e4);
      const r = new WebSocket(
        `${this.socketBaseUrl}${t}/${tr()}/${er(8)}/websocket`
      );
      r.onopen = () => {
        this.fetchSocketTokenTimeoutId && (clearTimeout(this.fetchSocketTokenTimeoutId), this.fetchSocketTokenTimeoutId = void 0), this.setConnectedSocket(), this.subscribeToStreams(!0);
      }, r.onerror = () => {
        this.fetchSocketTokenTimeoutId && (clearTimeout(this.fetchSocketTokenTimeoutId), this.fetchSocketTokenTimeoutId = void 0), this.setFatalSocket("onerror");
      }, r.onclose = (o) => {
        var l, f, n, u;
        this.fetchSocketTokenTimeoutId && (clearTimeout(this.fetchSocketTokenTimeoutId), this.fetchSocketTokenTimeoutId = void 0), o.code === 1006 && ((l = this.socket) == null ? void 0 : l.status) === "FATAL" ? this.setFatalSocket("connect_failure", {
          code: o.code,
          reason: "url not available",
          wasClean: o.wasClean,
          // @ts-expect-error access private variable
          url: (f = o == null ? void 0 : o.currentTarget) == null ? void 0 : f.url,
          // @ts-expect-error access private variable
          readyState: (n = o == null ? void 0 : o.currentTarget) == null ? void 0 : n.readyState
        }) : this.setFatalSocket("onclose", {
          code: o.code,
          reason: o.reason,
          wasClean: o.wasClean,
          // @ts-expect-error access private variable
          readyState: (u = o == null ? void 0 : o.currentTarget) == null ? void 0 : u.readyState
        });
      }, r.onmessage = (o) => {
        var n;
        this.setLastMessageDateToNow();
        const l = o.data.slice(0, 1), f = o.data.slice(1);
        switch (l) {
          // message that indicates the socket is open
          case "o":
            break;
          // a heartbeat
          case "h":
            this.handleHeartbeatMessage(o.data);
            break;
          // our standard expected message type
          case "a":
            this.handleSocketMessage(f);
            break;
          // at least two other possible message types in the sockjs protocol but we don't expect to use them
          // https://github.com/mark43/sockjs-client/blob/380a04b093540b3d13f9b9467dc4ac1fd882caad/lib/main.js#L282-L290
          default:
            (n = this.onWarning) == null || n.call(this, `Unexpected socket message type '${l}'`);
            break;
        }
      }, this.socket = {
        status: "CONNECTING",
        socket: r
      }, this.handleSocketStatusChange({
        timesConnected: this.timesConnected,
        status: this.socket.status,
        streamsLastMessageMapBeforeSocketClosure: this.streamsLastMessageMapBeforeLastSocketClosure
      });
    });
  }
  /**
   * This method should only ever be called by our underlying sockets `onopen` event.
   *   Here, we:
   *     - Subscribe to the initial set of streams that we should subscribe to
   *     - Start monitoring the frequency of messages so we can determine a potentially delinquent socket
   *     - Update our local socket reference to reflect a CONNECTED socket
   */
  setConnectedSocket() {
    if (this.socket && this.socket.status === "CONNECTING") {
      const t = this.socket.socket;
      if (!t)
        return;
      this.queueMonitorForMessageFrequency(), this.socket = K(H({}, this.socket), {
        status: "CONNECTED",
        socket: t,
        streamsLastMessageMap: {},
        lastMessageDate: /* @__PURE__ */ new Date()
      }), this.timesConnected++, this.subscribeToStreams(), this.handleSocketStatusChange({
        timesConnected: this.timesConnected,
        status: this.socket.status,
        streamsLastMessageMapBeforeSocketClosure: this.streamsLastMessageMapBeforeLastSocketClosure
      }), this.setLastMessageDateToNow();
    }
  }
  subscribeToStreams(t) {
    if (this.socket && this.socket.status === "CONNECTED") {
      const r = this.streamBroadcaster.getAllListenerStreamNames(), s = r.slice().sort().toString();
      (t || this.lastStreamSubscriptionHash !== s) && this.send(
        JSON.stringify({
          sessionId: rr,
          streams: r
        })
      ), this.lastStreamSubscriptionHash = s;
    }
  }
  /**
   * This method can either either by a socket during its onclose event, or manually by our own code
   *   when we detect that it has been too long since the last mesage (see startMonitoringMessageFrequency).
   *   Given this, we manually check to see whether our existing socket is closed, and if not we close it,
   *   prior to removing a reference to this socket altogether.
   *  We always prefer to have a socket connection, so we will always try to revive a socket once it
   *   has been closed.
   */
  setClosedSocket() {
    if (this.clearMonitorForMessageFrequency(), this.socket && (this.socket.status === "CONNECTED" || this.socket.status === "CONNECTING")) {
      this.socket.status === "CONNECTED" && (this.streamsLastMessageMapBeforeLastSocketClosure = this.socket.streamsLastMessageMap);
      const t = this.socket.socket;
      t && t.close();
    }
    this.socket = {
      status: "CLOSED"
    }, this.handleSocketStatusChange({
      timesConnected: this.timesConnected,
      status: this.socket.status,
      streamsLastMessageMapBeforeSocketClosure: this.streamsLastMessageMapBeforeLastSocketClosure
    });
  }
  setFatalSocket(t, r) {
    var s;
    if ((s = this.onFatal) == null || s.call(this, t, r), this.clearMonitorForMessageFrequency(), this.socket && (this.socket.status === "CONNECTED" || this.socket.status === "CONNECTING")) {
      this.socket.status === "CONNECTED" && (this.streamsLastMessageMapBeforeLastSocketClosure = this.socket.streamsLastMessageMap);
      const o = this.socket.socket;
      o && o.close();
    }
    this.socket = {
      status: "FATAL"
    }, this.handleSocketStatusChange({
      timesConnected: this.timesConnected,
      status: this.socket.status,
      streamsLastMessageMapBeforeSocketClosure: this.streamsLastMessageMapBeforeLastSocketClosure
    });
  }
  initiateFatalRecoveryLoop() {
    this.fatalRecoveryTimeoutId = setTimeout(() => {
      this.initiateFatalRecoveryLoop(), this.socket && this.socket.status === "FATAL" && !this.stopped && this.connectToSocket();
    }, this.fatalRecoveryCheckFrequency);
  }
  setLastMessageDateToNow() {
    this.socket && this.socket.status === "CONNECTED" && (this.socket.lastMessageDate = /* @__PURE__ */ new Date());
  }
  createMessagePayload(t, r, s) {
    return {
      streamName: t,
      messagePosition: r,
      payload: s
    };
  }
  handleSocketMessage(t) {
    var c, p, k;
    let r;
    try {
      r = JSON.parse(t)[0];
    } catch (b) {
      return;
    }
    const s = r[0], o = r[1];
    if (s === "_metadata") {
      const b = r[1], y = r[2];
      this.setPodName(b);
      const m = { timestamp: y };
      m.applicationName = (c = this.getApplicationName()) != null ? c : "unknown", this.send(JSON.stringify(m));
      return;
    }
    const l = r[2];
    if (l && this.onOutOfOrderMessage && ((p = this.socket) == null ? void 0 : p.status) === "CONNECTED") {
      const b = l.split("|");
      if (b.length >= 3) {
        const y = b[1], m = b[2], O = this.socket.streamsLastMessageMap[y];
        O && O.messagePosition !== m && this.onOutOfOrderMessage({
          streamName: y,
          messagePosition: m
        });
      }
    }
    let f;
    try {
      f = JSON.parse(r[3]);
    } catch (b) {
      return;
    }
    const n = r[5];
    let u;
    if (n)
      try {
        u = JSON.parse(n);
      } catch (b) {
      }
    const h = this.createMessagePayload(s, o, f);
    this.updateStreamsLastMessageMap(h), this.streamBroadcaster.onMessage(h), (k = this.onMessage) == null || k.call(this, h, u);
  }
  handleSocketStatusChange(t) {
    var s;
    const r = K(H({}, t), {
      podName: this.getPodName()
    });
    this.streamBroadcaster.onSocketStatusChange(r), (s = this.onSocketStatusChange) == null || s.call(this, r);
  }
  getStreamsLastMesageMap() {
    if (this.socket && this.socket.status === "CONNECTED")
      return this.socket.streamsLastMessageMap;
  }
  updateStreamsLastMessageMap(t) {
    this.socket && this.socket.status === "CONNECTED" && (this.socket.streamsLastMessageMap[t.streamName] = t);
  }
  send(t) {
    var s, o, l;
    const r = JSON.stringify(t);
    ((s = this.socket) == null ? void 0 : s.status) !== "CONNECTED" || ((o = this.socket) == null ? void 0 : o.socket.readyState) !== WebSocket.OPEN || ((l = this.socket) == null ? void 0 : l.status) === "CONNECTED" && this.socket.socket.readyState === WebSocket.OPEN && this.socket.socket.send(`[${r}]`);
  }
  handleOpenMessage(t) {
    if (!t || !t.startsWith("o-"))
      return;
    const r = t.slice(2);
    this.podName = r;
  }
  handleHeartbeatMessage(t) {
    this.send(t != null ? t : "h");
  }
  queueMonitorForMessageFrequency() {
    this.messageMonitorTimeoutId = setTimeout(() => {
      if (!this.messageTimeoutThreshold)
        throw new Error("messageTimeoutTreshold unexpectedly undefined");
      this.socket && // We have to double check this because we're in a setTimeout,
      // so this.socket may have been mutated
      this.socket.status === "CONNECTED" && qt(/* @__PURE__ */ new Date(), this.socket.lastMessageDate) > this.messageTimeoutThreshold ? this.setFatalSocket("insufficient_message_frequency") : this.queueMonitorForMessageFrequency();
    }, this.messageTimeoutCheckFrequency);
  }
  clearMonitorForMessageFrequency() {
    this.messageMonitorTimeoutId && clearTimeout(this.messageMonitorTimeoutId);
  }
}
class lr {
  constructor() {
    this.socketListeners = [], this.streamListeners = {};
  }
  registerParentSocket(t) {
    this.socket = t;
  }
  addSocketListener(t) {
    let r = !1;
    for (const s of this.socketListeners)
      t === s && (r = !0);
    return r || (this.socketListeners.push(t), t.invokeOnInitialize && this.socket && t.onSocketStatusChange({
      streamsLastMessageMapBeforeSocketClosure: this.socket.getStreamsLastMessageMapBeforeLastSocketClosure(),
      timesConnected: this.socket.getTimesConnected(),
      status: this.socket.getSocketStatus()
    })), () => {
      for (let s = 0; s < this.socketListeners.length; s++)
        if (this.socketListeners[s] === t) {
          this.socketListeners.splice(s, 1);
          break;
        }
    };
  }
  addStreamListener(t) {
    const r = t.streamNames, s = /* @__PURE__ */ new Set();
    return r.forEach((o) => {
      this.streamListeners[o] || (this.streamListeners[o] = []);
      const l = this.streamListeners[o];
      if (typeof l == "undefined")
        throw new Error("Unexpectedly did not find array of existing listeners");
      for (const f of l)
        t === f && s.add(t);
      s.has(t) || (l.push(t), this.socket && this.socket.subscribeToStreams());
    }), () => {
      r.forEach((o) => {
        const l = this.streamListeners[o];
        if (typeof l == "undefined")
          throw new Error("Unexpectedly did not find array of existing listeners");
        for (let f = 0; f < (l == null ? void 0 : l.length); f++)
          if (l[f] === t) {
            l.splice(f, 1);
            break;
          }
      }), this.socket && this.socket.subscribeToStreams();
    };
  }
  getSocketStatus() {
    var t;
    return (t = this.socket) == null ? void 0 : t.getSocketStatus();
  }
  /**
   * SocketStatusChangeEvents should be published to all listeners, regardless
   *   of which stream they are listeneing to.
   *   This method handles setting listeners to buffering and also flushing their
   *   buffers when appropriate.
   */
  onSocketStatusChange(t) {
    var r, s;
    for (const o of this.socketListeners)
      o.onSocketStatusChange(t);
    for (const [o, l] of Object.entries(this.streamListeners))
      for (const f of l)
        (s = f.onSocketStatusChange) == null || s.call(f, K(H({}, t), {
          lastMessage: (r = t.streamsLastMessageMapBeforeSocketClosure) == null ? void 0 : r[o]
        }));
  }
  /**
   * MessagePayload<T> should only be delivered to listeners which are
   *   listening to the stream which the message pertains to.
   */
  onMessage(t) {
    var s;
    const r = this.streamListeners[t.streamName];
    if (typeof r != "undefined")
      for (const o of r)
        (s = o.onMessage) == null || s.call(o, t);
  }
  /**
   *
   * This method allows our Socket to know all streams that it needs
   *   to subscribe to when it is being revived.
   */
  getAllListenerStreamNames() {
    const t = [], r = Object.keys(this.streamListeners);
    for (const s of r) {
      const o = this.streamListeners[s];
      o && o.length > 0 && t.push(s);
    }
    return t;
  }
}
var ae = { exports: {} }, Y = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var he, et;
function ot() {
  if (et) return he;
  et = 1;
  var a = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function s(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var f = {}, n = 0; n < 10; n++)
        f["_" + String.fromCharCode(n)] = n;
      var u = Object.getOwnPropertyNames(f).map(function(c) {
        return f[c];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var h = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        h[c] = c;
      }), Object.keys(Object.assign({}, h)).join("") === "abcdefghijklmnopqrst";
    } catch (c) {
      return !1;
    }
  }
  return he = o() ? Object.assign : function(l, f) {
    for (var n, u = s(l), h, c = 1; c < arguments.length; c++) {
      n = Object(arguments[c]);
      for (var p in n)
        t.call(n, p) && (u[p] = n[p]);
      if (a) {
        h = a(n);
        for (var k = 0; k < h.length; k++)
          r.call(n, h[k]) && (u[h[k]] = n[h[k]]);
      }
    }
    return u;
  }, he;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tt;
function ar() {
  if (tt) return Y;
  tt = 1, ot();
  var a = A, t = 60103;
  if (Y.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    t = r("react.element"), Y.Fragment = r("react.fragment");
  }
  var s = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(n, u, h) {
    var c, p = {}, k = null, b = null;
    h !== void 0 && (k = "" + h), u.key !== void 0 && (k = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (c in u) o.call(u, c) && !l.hasOwnProperty(c) && (p[c] = u[c]);
    if (n && n.defaultProps) for (c in u = n.defaultProps, u) p[c] === void 0 && (p[c] = u[c]);
    return { $$typeof: t, type: n, key: k, ref: b, props: p, _owner: s.current };
  }
  return Y.jsx = f, Y.jsxs = f, Y;
}
var pe = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rt;
function nr() {
  return rt || (rt = 1, (function(a) {
    process.env.NODE_ENV !== "production" && (function() {
      var t = A, r = ot(), s = 60103, o = 60106;
      a.Fragment = 60107;
      var l = 60108, f = 60114, n = 60109, u = 60110, h = 60112, c = 60113, p = 60120, k = 60115, b = 60116, y = 60121, m = 60122, O = 60117, F = 60129, ye = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var w = Symbol.for;
        s = w("react.element"), o = w("react.portal"), a.Fragment = w("react.fragment"), l = w("react.strict_mode"), f = w("react.profiler"), n = w("react.provider"), u = w("react.context"), h = w("react.forward_ref"), c = w("react.suspense"), p = w("react.suspense_list"), k = w("react.memo"), b = w("react.lazy"), y = w("react.block"), m = w("react.server.block"), O = w("react.fundamental"), w("react.scope"), w("react.opaque.id"), F = w("react.debug_trace_mode"), w("react.offscreen"), ye = w("react.legacy_hidden");
      }
      var ve = typeof Symbol == "function" && Symbol.iterator, it = "@@iterator";
      function ut(e) {
        if (e === null || typeof e != "object")
          return null;
        var i = ve && e[ve] || e[it];
        return typeof i == "function" ? i : null;
      }
      var I = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function N(e) {
        {
          for (var i = arguments.length, d = new Array(i > 1 ? i - 1 : 0), v = 1; v < i; v++)
            d[v - 1] = arguments[v];
          ct("error", e, d);
        }
      }
      function ct(e, i, d) {
        {
          var v = I.ReactDebugCurrentFrame, T = v.getStackAddendum();
          T !== "" && (i += "%s", d = d.concat([T]));
          var S = d.map(function(_) {
            return "" + _;
          });
          S.unshift("Warning: " + i), Function.prototype.apply.call(console[e], console, S);
        }
      }
      var ft = !1;
      function lt(e) {
        return !!(typeof e == "string" || typeof e == "function" || e === a.Fragment || e === f || e === F || e === l || e === c || e === p || e === ye || ft || typeof e == "object" && e !== null && (e.$$typeof === b || e.$$typeof === k || e.$$typeof === n || e.$$typeof === u || e.$$typeof === h || e.$$typeof === O || e.$$typeof === y || e[0] === m));
      }
      function dt(e, i, d) {
        var v = i.displayName || i.name || "";
        return e.displayName || (v !== "" ? d + "(" + v + ")" : d);
      }
      function ge(e) {
        return e.displayName || "Context";
      }
      function P(e) {
        if (e == null)
          return null;
        if (typeof e.tag == "number" && N("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
          return e.displayName || e.name || null;
        if (typeof e == "string")
          return e;
        switch (e) {
          case a.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case f:
            return "Profiler";
          case l:
            return "StrictMode";
          case c:
            return "Suspense";
          case p:
            return "SuspenseList";
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case u:
              var i = e;
              return ge(i) + ".Consumer";
            case n:
              var d = e;
              return ge(d._context) + ".Provider";
            case h:
              return dt(e, e.render, "ForwardRef");
            case k:
              return P(e.type);
            case y:
              return P(e._render);
            case b: {
              var v = e, T = v._payload, S = v._init;
              try {
                return P(S(T));
              } catch (_) {
                return null;
              }
            }
          }
        return null;
      }
      var J = 0, ke, _e, Se, be, Te, Oe, Ce;
      function we() {
      }
      we.__reactDisabledLog = !0;
      function ht() {
        {
          if (J === 0) {
            ke = console.log, _e = console.info, Se = console.warn, be = console.error, Te = console.group, Oe = console.groupCollapsed, Ce = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: we,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          J++;
        }
      }
      function pt() {
        {
          if (J--, J === 0) {
            var e = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, e, {
                value: ke
              }),
              info: r({}, e, {
                value: _e
              }),
              warn: r({}, e, {
                value: Se
              }),
              error: r({}, e, {
                value: be
              }),
              group: r({}, e, {
                value: Te
              }),
              groupCollapsed: r({}, e, {
                value: Oe
              }),
              groupEnd: r({}, e, {
                value: Ce
              })
            });
          }
          J < 0 && N("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var se = I.ReactCurrentDispatcher, oe;
      function $(e, i, d) {
        {
          if (oe === void 0)
            try {
              throw Error();
            } catch (T) {
              var v = T.stack.trim().match(/\n( *(at )?)/);
              oe = v && v[1] || "";
            }
          return `
` + oe + e;
        }
      }
      var ie = !1, V;
      {
        var mt = typeof WeakMap == "function" ? WeakMap : Map;
        V = new mt();
      }
      function Ee(e, i) {
        if (!e || ie)
          return "";
        {
          var d = V.get(e);
          if (d !== void 0)
            return d;
        }
        var v;
        ie = !0;
        var T = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = se.current, se.current = null, ht();
        try {
          if (i) {
            var _ = function() {
              throw Error();
            };
            if (Object.defineProperty(_.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(_, []);
              } catch (D) {
                v = D;
              }
              Reflect.construct(e, [], _);
            } else {
              try {
                _.call();
              } catch (D) {
                v = D;
              }
              e.call(_.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (D) {
              v = D;
            }
            e();
          }
        } catch (D) {
          if (D && v && typeof D.stack == "string") {
            for (var g = D.stack.split(`
`), M = v.stack.split(`
`), C = g.length - 1, E = M.length - 1; C >= 1 && E >= 0 && g[C] !== M[E]; )
              E--;
            for (; C >= 1 && E >= 0; C--, E--)
              if (g[C] !== M[E]) {
                if (C !== 1 || E !== 1)
                  do
                    if (C--, E--, E < 0 || g[C] !== M[E]) {
                      var j = `
` + g[C].replace(" at new ", " at ");
                      return typeof e == "function" && V.set(e, j), j;
                    }
                  while (C >= 1 && E >= 0);
                break;
              }
          }
        } finally {
          ie = !1, se.current = S, pt(), Error.prepareStackTrace = T;
        }
        var B = e ? e.displayName || e.name : "", Be = B ? $(B) : "";
        return typeof e == "function" && V.set(e, Be), Be;
      }
      function Re(e, i, d) {
        return Ee(e, !1);
      }
      function yt(e) {
        var i = e.prototype;
        return !!(i && i.isReactComponent);
      }
      function G(e, i, d) {
        if (e == null)
          return "";
        if (typeof e == "function")
          return Ee(e, yt(e));
        if (typeof e == "string")
          return $(e);
        switch (e) {
          case c:
            return $("Suspense");
          case p:
            return $("SuspenseList");
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case h:
              return Re(e.render);
            case k:
              return G(e.type, i, d);
            case y:
              return Re(e._render);
            case b: {
              var v = e, T = v._payload, S = v._init;
              try {
                return G(S(T), i, d);
              } catch (_) {
              }
            }
          }
        return "";
      }
      var Me = {}, Ne = I.ReactDebugCurrentFrame;
      function z(e) {
        if (e) {
          var i = e._owner, d = G(e.type, e._source, i ? i.type : null);
          Ne.setExtraStackFrame(d);
        } else
          Ne.setExtraStackFrame(null);
      }
      function vt(e, i, d, v, T) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var _ in e)
            if (S(e, _)) {
              var g = void 0;
              try {
                if (typeof e[_] != "function") {
                  var M = Error((v || "React class") + ": " + d + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw M.name = "Invariant Violation", M;
                }
                g = e[_](i, _, v, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (C) {
                g = C;
              }
              g && !(g instanceof Error) && (z(T), N("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", d, _, typeof g), z(null)), g instanceof Error && !(g.message in Me) && (Me[g.message] = !0, z(T), N("Failed %s type: %s", d, g.message), z(null));
            }
        }
      }
      var xe = I.ReactCurrentOwner, ue = Object.prototype.hasOwnProperty, gt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, je, De;
      function kt(e) {
        if (ue.call(e, "ref")) {
          var i = Object.getOwnPropertyDescriptor(e, "ref").get;
          if (i && i.isReactWarning)
            return !1;
        }
        return e.ref !== void 0;
      }
      function _t(e) {
        if (ue.call(e, "key")) {
          var i = Object.getOwnPropertyDescriptor(e, "key").get;
          if (i && i.isReactWarning)
            return !1;
        }
        return e.key !== void 0;
      }
      function St(e, i) {
        typeof e.ref == "string" && xe.current;
      }
      function bt(e, i) {
        {
          var d = function() {
            je || (je = !0, N("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
          };
          d.isReactWarning = !0, Object.defineProperty(e, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function Tt(e, i) {
        {
          var d = function() {
            De || (De = !0, N("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
          };
          d.isReactWarning = !0, Object.defineProperty(e, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var Ot = function(e, i, d, v, T, S, _) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: s,
          // Built-in properties that belong on the element
          type: e,
          key: i,
          ref: d,
          props: _,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: v
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: T
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function Ct(e, i, d, v, T) {
        {
          var S, _ = {}, g = null, M = null;
          d !== void 0 && (g = "" + d), _t(i) && (g = "" + i.key), kt(i) && (M = i.ref, St(i, T));
          for (S in i)
            ue.call(i, S) && !gt.hasOwnProperty(S) && (_[S] = i[S]);
          if (e && e.defaultProps) {
            var C = e.defaultProps;
            for (S in C)
              _[S] === void 0 && (_[S] = C[S]);
          }
          if (g || M) {
            var E = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
            g && bt(_, E), M && Tt(_, E);
          }
          return Ot(e, g, M, T, v, xe.current, _);
        }
      }
      var ce = I.ReactCurrentOwner, Pe = I.ReactDebugCurrentFrame;
      function q(e) {
        if (e) {
          var i = e._owner, d = G(e.type, e._source, i ? i.type : null);
          Pe.setExtraStackFrame(d);
        } else
          Pe.setExtraStackFrame(null);
      }
      var fe;
      fe = !1;
      function le(e) {
        return typeof e == "object" && e !== null && e.$$typeof === s;
      }
      function Le() {
        {
          if (ce.current) {
            var e = P(ce.current.type);
            if (e)
              return `

Check the render method of \`` + e + "`.";
          }
          return "";
        }
      }
      function wt(e) {
        return "";
      }
      var Ae = {};
      function Et(e) {
        {
          var i = Le();
          if (!i) {
            var d = typeof e == "string" ? e : e.displayName || e.name;
            d && (i = `

Check the top-level render call using <` + d + ">.");
          }
          return i;
        }
      }
      function Fe(e, i) {
        {
          if (!e._store || e._store.validated || e.key != null)
            return;
          e._store.validated = !0;
          var d = Et(i);
          if (Ae[d])
            return;
          Ae[d] = !0;
          var v = "";
          e && e._owner && e._owner !== ce.current && (v = " It was passed a child from " + P(e._owner.type) + "."), q(e), N('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, v), q(null);
        }
      }
      function Ie(e, i) {
        {
          if (typeof e != "object")
            return;
          if (Array.isArray(e))
            for (var d = 0; d < e.length; d++) {
              var v = e[d];
              le(v) && Fe(v, i);
            }
          else if (le(e))
            e._store && (e._store.validated = !0);
          else if (e) {
            var T = ut(e);
            if (typeof T == "function" && T !== e.entries)
              for (var S = T.call(e), _; !(_ = S.next()).done; )
                le(_.value) && Fe(_.value, i);
          }
        }
      }
      function Rt(e) {
        {
          var i = e.type;
          if (i == null || typeof i == "string")
            return;
          var d;
          if (typeof i == "function")
            d = i.propTypes;
          else if (typeof i == "object" && (i.$$typeof === h || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          i.$$typeof === k))
            d = i.propTypes;
          else
            return;
          if (d) {
            var v = P(i);
            vt(d, e.props, "prop", v, e);
          } else if (i.PropTypes !== void 0 && !fe) {
            fe = !0;
            var T = P(i);
            N("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", T || "Unknown");
          }
          typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && N("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Mt(e) {
        {
          for (var i = Object.keys(e.props), d = 0; d < i.length; d++) {
            var v = i[d];
            if (v !== "children" && v !== "key") {
              q(e), N("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), q(null);
              break;
            }
          }
          e.ref !== null && (q(e), N("Invalid attribute `ref` supplied to `React.Fragment`."), q(null));
        }
      }
      function qe(e, i, d, v, T, S) {
        {
          var _ = lt(e);
          if (!_) {
            var g = "";
            (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var M = wt();
            M ? g += M : g += Le();
            var C;
            e === null ? C = "null" : Array.isArray(e) ? C = "array" : e !== void 0 && e.$$typeof === s ? (C = "<" + (P(e.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : C = typeof e, N("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", C, g);
          }
          var E = Ct(e, i, d, T, S);
          if (E == null)
            return E;
          if (_) {
            var j = i.children;
            if (j !== void 0)
              if (v)
                if (Array.isArray(j)) {
                  for (var B = 0; B < j.length; B++)
                    Ie(j[B], e);
                  Object.freeze && Object.freeze(j);
                } else
                  N("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ie(j, e);
          }
          return e === a.Fragment ? Mt(E) : Rt(E), E;
        }
      }
      function Nt(e, i, d) {
        return qe(e, i, d, !0);
      }
      function xt(e, i, d) {
        return qe(e, i, d, !1);
      }
      var jt = xt, Dt = Nt;
      a.jsx = jt, a.jsxs = Dt;
    })();
  })(pe)), pe;
}
var at;
function sr() {
  return at || (at = 1, process.env.NODE_ENV === "production" ? ae.exports = ar() : ae.exports = nr()), ae.exports;
}
var or = sr();
const ir = or.jsx, me = A.createContext(void 0);
function dr(a) {
  return (
    // Unfortunate need for this assertion because of the absence of higher-kinded types: https://github.com/Microsoft/TypeScript/issues/1213
    // would have preferred to write the
    /* @__PURE__ */ ir(
      me.Provider,
      {
        value: a.streamBroadcaster,
        children: a.children
      }
    )
  );
}
function hr() {
  return (a) => {
    const t = A.useContext(
      me
    );
    if (typeof t == "undefined")
      throw new Error("Unexpectedly did not find StreamBroadcaster on context");
    A.useEffect(() => {
      let r;
      return a && (r = t.addStreamListener(a)), () => {
        r && r();
      };
    }, [a, t]);
  };
}
function pr() {
  return (a) => {
    const t = A.useContext(
      me
    );
    if (typeof t == "undefined")
      throw new Error("Unexpectedly did not find StreamBroadcaster on context");
    return A.useEffect(() => {
      const r = t.addSocketListener(a);
      return () => {
        r();
      };
    }, [a, t]), {
      getSocketStatus: t.getSocketStatus.bind(t)
    };
  };
}
export {
  fr as Socket,
  lr as StreamBroadcaster,
  me as StreamBroadcasterContext,
  dr as StreamBroadcasterProvider,
  pr as createUseSocketStatus,
  hr as createUseStream
};
